import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, textColumn } from "./ColumnHelpers";

export function column_MicrosList(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "microsList", "microsList", {
		isDisabled: (row) => {
			const job = context.jobs.find((j) => j.id === row.original.id);
			return !job?.files.pointsSHP || job.files.pointsSHP.length === 0;
		},
	});
}
